var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.642822,
    width: 49.7143,
    height: 49.7143,
    rx: 13.8095,
    fill: "#AB54A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_8311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6632 18.7844H30.2573V17.3456C30.2573 16.1317 29.197 15.1428 27.8953 15.1428H21.8191C20.5175 15.1428 19.4571 16.1317 19.4571 17.3456V18.7844H12.0456C10.7327 18.7844 9.66675 19.7785 9.66675 21.0028V30.3161H40.0477V21.0028C40.0477 19.7785 38.9817 18.7844 37.6688 18.7844H37.6632ZM21.2412 17.3456C21.2412 17.0473 21.4993 16.8066 21.8191 16.8066H27.8953C28.2151 16.8066 28.4732 17.0473 28.4732 17.3456V18.7844H21.2469V17.3456H21.2412Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0762 33.3088C27.0762 33.5547 26.863 33.7536 26.5993 33.7536H22.9412C22.6775 33.7536 22.4643 33.5547 22.4643 33.3088V31.9014H9.66675V34.3239C9.66675 35.5482 10.7327 36.5423 12.0456 36.5423H37.6632C38.9761 36.5423 40.0421 35.5482 40.0421 34.3239V31.9014H27.0762V33.3088Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 30.3057H27.3285V33.3665C27.3285 33.6281 27.0984 33.8426 26.8179 33.8426H22.8849C22.6044 33.8426 22.3744 33.6281 22.3744 33.3665V30.3057H22.38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_8311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.381,
    height: 21.4048,
    fill: "white",
    transform: "translate(9.66675 15.1428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work-icon.bd524b3e7142f7d1cf37ba2dbe7b5688.svg";
export { ForwardRef as ReactComponent };